import React from 'react';
import * as componentStyle from './upcomingCaseStudies.module.scss';
import { navigate } from 'gatsby';
import { Heading } from '../../../interface/header.interface';
import ButtonComponent from '../../Home/ButtonComponent/ButtonComponent';
import HeadingComponent from '../../HeadingComponent/HeadingComponent';
import CaseStudySlider from './Component/CaseStudySlider/CaseStudySlider';



interface ButtonInterface {
  buttonContext: string | null;
  slug: string | null;
}
export interface UpcomingCaseStudiesProps {
  heading: Heading[] | null;
  button: ButtonInterface | null;
}

export default function UpcomingCaseStudies({ data }: { data: UpcomingCaseStudiesProps | null }) {
  return (
    <>
      {data?.heading && (
        <section className={componentStyle.upcomingCaseStudies}>
          <div className={componentStyle.upcomingCaseStudies__container}>
            <div className={componentStyle.upcomingCaseStudies__headingArea}>
              {data?.heading && <HeadingComponent data={data.heading} />}

              {data?.button?.buttonContext && (
                <div className={componentStyle.upcomingCaseStudies__buttonArea}>
                  <ButtonComponent 
                    buttonText={data?.button?.buttonContext.toUpperCase()} 
                    type={undefined} 
                    buttonStyle={undefined} 
                    onClick={() => navigate(data.button?.slug || '#')} 
                    disabled={undefined} 
                    loading={undefined} 
                    className={undefined} 
                  />
                </div>
              )}
            </div>
          </div>

          <CaseStudySlider />
        </section>
      )}
    </>
  )
}
